var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_228939050710424114234543565849071381555",
    d: "M16.878 3.512c6.627 0 12 5.373 12 12v3.317c0 6.628-5.373 12-12 12h-.976c-3.108 0-5.94-1.182-8.072-3.12l10.926-.002c3.786 0 6.87-3.004 6.996-6.759l.004-.24v-7.074c0-3.785-3.005-6.869-6.76-6.996l-.24-.004H7.83c2.131-1.94 4.964-3.122 8.072-3.122h.976zm-4.39 4.683l9.703 8.39-9.703 8.39v-2.731H3.122V10.927h9.366V8.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_100831104083576924134874752003365480012",
    d: "M0.359 0.36H32.818000000000005V33.981H0.359z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_72180258950729143425678379447818832484",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -620) translate(148 612) translate(15 6) translate(.22 .83)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_70872924398747384123954374179655027979",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_228939050710424114234543565849071381555"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_228939050710424114234543565849071381555"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_70872924398747384123954374179655027979)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_100831104083576924134874752003365480012"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_72180258950729143425678379447818832484)",
    xlinkHref: "#hinava_random_uuid_100831104083576924134874752003365480012"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/sources.614fd7c98d3d2efb7ed263de57a66a1b.svg";
export { ForwardRef as ReactComponent };